export enum ExpandState {
  EXPAND_ALL = 'expand-all',
  COLLAPSE_ALL = 'collapse-all',
}
export type ExpandStateType = ExpandState | null
